import {
  FpWebsocketMessage,
  useListenForFpWebsocketMessages
} from '@flicent/fieldpulse-react-component-library-frontend';

import {
  CustomFormPublicLinkWebsocketMessageAction,
  WEBSOCKET_ORIGIN,
  WEBSOCKET_TYPE_CUSTOM_FORM_PUBLIC_LINK
} from '@/constants';


export interface PublicLinkCustomFormReportWebsocketMessage<A = string, D = any> extends FpWebsocketMessage<typeof WEBSOCKET_TYPE_CUSTOM_FORM_PUBLIC_LINK, A, D> {

}

export interface PublicLinkCustomFormReportFillPdfProgressWebsocketMessage extends PublicLinkCustomFormReportWebsocketMessage<CustomFormPublicLinkWebsocketMessageAction.PDF_GENERATION_PROGRESS, {
  progress: number;
  current_step: string;
}> {
}

export interface PublicLinkCustomFormReportFillPdfFinishWebsocketMessage extends PublicLinkCustomFormReportWebsocketMessage<CustomFormPublicLinkWebsocketMessageAction.PDF_GENERATED, {
  pdf_file_url: string;
}> {
}

export interface PublicLinkCustomFormReportFillPdfErrorWebsocketMessage extends PublicLinkCustomFormReportWebsocketMessage<CustomFormPublicLinkWebsocketMessageAction.PDF_GENERATION_ERROR, {
  error_detail: string;
}> {
}

type CustomFormPublicLinkWebsocketMessage =
  PublicLinkCustomFormReportFillPdfProgressWebsocketMessage
  | PublicLinkCustomFormReportFillPdfFinishWebsocketMessage
  | PublicLinkCustomFormReportFillPdfErrorWebsocketMessage;


interface UseListenForPublicLinkCustomFormWebsocketMessagesArgument {
  encryptedPublicLinkId: string | null;
  onFillPdfProgress: (progress: number, currentStep: string) => void;
  onFillPdfGenerated: (pdfFileUrl: string) => void;
  onFillPdfGenerationError: (errorDetail: string) => void;
}

export const useListenForPublicLinkCustomFormWebsocketMessages = ({
                                                                    encryptedPublicLinkId,
                                                                    onFillPdfProgress,
                                                                    onFillPdfGenerated,
                                                                    onFillPdfGenerationError,
                                                                  }: UseListenForPublicLinkCustomFormWebsocketMessagesArgument) => {
  useListenForFpWebsocketMessages(encryptedPublicLinkId ? `${ WEBSOCKET_ORIGIN }/public-link/custom-form-report/socket/${ encryptedPublicLinkId }` : null, (message) => {
    if (message.type === WEBSOCKET_TYPE_CUSTOM_FORM_PUBLIC_LINK) {
      const customFormPublicLinkMessage = message as CustomFormPublicLinkWebsocketMessage;
      switch (customFormPublicLinkMessage.action) {
        case CustomFormPublicLinkWebsocketMessageAction.PDF_GENERATION_PROGRESS: {
          onFillPdfProgress(customFormPublicLinkMessage.data.progress, customFormPublicLinkMessage.data.current_step);
          break;
        }
        case CustomFormPublicLinkWebsocketMessageAction.PDF_GENERATED: {
          onFillPdfGenerated(customFormPublicLinkMessage.data.pdf_file_url);
          break;
        }
        case CustomFormPublicLinkWebsocketMessageAction.PDF_GENERATION_ERROR: {
          onFillPdfGenerationError(customFormPublicLinkMessage.data.error_detail);
          break;
        }
        default: {
          console.warn('Unknown custom form report message:', customFormPublicLinkMessage);
        }
      }
    }
  });
};